<div *ngIf="!!successMessage" class="vzc-success-banner">
  <mat-icon
    svgIcon="ds-success"
    aria-hidden="false"
    i18n-aria-label="@@S_ACCOUNT_ACTIVATION_SUCCESS_ICON"
    aria-label="Success icon"
  ></mat-icon>
  {{ successMessage }}
</div>
